import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type SuspensionStartedProps = BaseNotificationItemProps & {
  type: 'suspension_started'
  program: {
    id: string
    displayName: string
    color: string
    iconType?: string
  }
}

export function SuspensionStarted({ program, ...props }: SuspensionStartedProps) {
  return (
    <NotificationItem
      {...props}
      title={`${program.displayName} Suspension Started`}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{`You have been suspended from working on ${program.displayName}.`}</p>
      }
    />
  )
}
